import { createContext, useContext, useEffect } from 'react';

/** A point in pixels of the displayed page, from the top left corner of its content. */
export type DisplayedPagePoint = { x: number; y: number };

/** What the page's Ctrl gesture tells the selection of the page's OCR words. */
export type OcrWordsSelectionGesture = {
  start: (point: DisplayedPagePoint) => void;
  move: (point: DisplayedPagePoint) => void;
  end: () => void;
  clear: () => void;
};

type RegisterOcrWordsSelectionGesture = (gesture: OcrWordsSelectionGesture) => () => void;

// Outside a page nothing starts the gesture, so the default registers nowhere.
export const OcrWordsSelectionGestureContext = createContext<RegisterOcrWordsSelectionGesture>(() => () => undefined);

export const useRegisterOcrWordsSelectionGesture = (gesture: OcrWordsSelectionGesture) => {
  const register = useContext(OcrWordsSelectionGestureContext);
  useEffect(() => register(gesture), [register, gesture]);
};
